<template>
  <v-navigation-drawer
    floating
    permanent
    app
    v-if='loggedIn'
    class="elevation-10"
  >
    <v-list
    dense
    rounded
    >
      <v-list-item>
        <v-list-item-content align="center">
          <v-list-item-title class="text-h6">
            <img src="drome_logo_180x.jpeg">
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-for="item in navOptions"
        :key="item.title"
        link
        :to='item.link'
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <template v-slot:append>
      <div class="pa-4">
        <v-btn block color="primary" v-on:click="logout">
          <v-list-item-icon>
            <v-icon>logout</v-icon>
          </v-list-item-icon>
          Logout
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import store from '../store';

export default {
  name: 'LeftNav',
  data: () => ({
    items: [
      { title: 'Login', icon: 'dashboard', link: '/login', allowAnon: true},
      { title: 'Movies', icon: 'dashboard', link: '/', allowAnon: true },
      { title: 'Movies', icon: 'dashboard', link: '/', allowAnon: false },
      { title: 'Admin', icon: 'dashboard_customize', link: '/admin',allowAnon: false },
    ],
  }),
  methods: {
    logout: function () {
      this.$router.push('/logout')
    }
  },
  computed: {
    navOptions() {
      let options = this.items.filter(i => i.allowAnon != store.getters.isLoggedIn);
      return options;
    },
    loggedIn() {
      return store.getters.isLoggedIn
    }
  },
};
</script>
